<div class="p-lg-3">
    <div class="row">
        <app-solicitud-card [data]="this.contenidos"></app-solicitud-card>
    </div>
    <div class="row pt-3">
        <app-solicitud-historial></app-solicitud-historial>
    </div>
</div>